export enum SubscriptionExportStatus {
  REQUESTED = "requested",
  PROCESSING = "processing",
  READY = "ready"
}

export type SubscriptionExportReadyResponse = {
  status: SubscriptionExportStatus.READY;
  downloadUrl: string;
};

export type SubscriptionExportPendingResponse = {
  status: SubscriptionExportStatus.PROCESSING | SubscriptionExportStatus.REQUESTED;
};

export type GetSubscriptionExportResponse =
  | SubscriptionExportReadyResponse
  | SubscriptionExportPendingResponse;
